export enum CsvFormats {
    VIPPS = 'Vipps',
    KLARNA = 'Klarna',
    CUSTOM = 'Custom'
}


export type ImportAccountConfiguration = {
    incomeAccount: string,
    debitAccount: string,
    feesAccount: string,
    fundsAccount: string
}
export const defaultAccountConfig = (): ImportAccountConfiguration => {
    return {
        incomeAccount: '3000',
        debitAccount: '1541',
        feesAccount: '7770',
        fundsAccount: '1920'
    }
}

export type EntryLineFields = {
    date: string;
    debitAccount: string;
    debitVat: string;
    creditAccount: string;
    creditVat: string;
    description: string;
    amount: string;
    project?: string;
    department?: string;
    accrAcc?: string;
    accrStartYear?: string;
    accrStartMonthOneIndexed?: string;
    accrDuration?: string
}

export const vippsMapper = (data: string[][], importConfig: ImportAccountConfiguration): EntryLineFields[] => {
    const entryLines:EntryLineFields[] = []
    data.filter(line => {
            return line.length > 11 && line[0] === 'SettlementInfo' && line[2] !== 'SaleUnitNumber'
        })
        .forEach((settlement: string[]) => {
            const [,,,date,settlementId,,gross,,fee,refund,net] = settlement
            //TODO: How to handle refund
            //TODO: Better name for importConfig.debitAccount
            if(refund) {
                console.warn('TODO: Handle refund')
            }
            entryLines.push({
                date,
                debitAccount: importConfig.fundsAccount,
                debitVat: '0',
                creditAccount:  '',
                creditVat: '0',
                description: 'Oppgjør Vipps, settlement: '+settlementId,
                amount: net
            })
            entryLines.push({
                date,
                debitAccount: importConfig.feesAccount,
                debitVat: '0',
                creditAccount:  '',
                creditVat: '0',
                description: 'Oppgjør Vipps, settlement: '+settlementId,
                amount: (Number(fee.replace(',','.')) * -1).toString()
            })
            entryLines.push({
                date,
                debitAccount: '',
                debitVat: '0',
                creditAccount:  importConfig.debitAccount,
                creditVat: '0',
                description: 'Oppgjør Vipps, settlement: '+settlementId,
                amount: gross
            })
        })

    return entryLines
}

export const klarnaMapper = (data: string[][], importConfig: ImportAccountConfiguration): EntryLineFields[] => {
    const entryLines:EntryLineFields[] = []
    data.filter((line) => {
        //first column should be a number, or a string that parses to a number
        return line.length > 5 && !isNaN(Number(line[0]))
    }).forEach(settlementLine => {
        const [saleAmount, feeAmount, returnAmount, reversalAmount, commissionAmount, holdbackAmount, repayAmount, releaseAmount, feeCorrectionAmmount, settlementAmount, taxAmount, paymentReference, paymentCurrency, date] = settlementLine
        //TODO: Handle return, reversal, commission, holdback, repay, release, feeCorrection
        console.warn('Handle return, reversal, commission, holdback, repay, release, feeCorrection', returnAmount, reversalAmount, commissionAmount, holdbackAmount, repayAmount, releaseAmount, feeCorrectionAmmount, taxAmount, paymentCurrency)
        entryLines.push({
            date: date?.substring(0,10),
            debitAccount: importConfig.fundsAccount,
            debitVat: '0',
            creditAccount:  '',
            creditVat: '0',
            description: 'Oppgjør Klarna, ref: '+paymentReference,
            amount: settlementAmount
        })
        entryLines.push({
            date: date?.substring(0,10),
            debitAccount: importConfig.feesAccount,
            debitVat: '0',
            creditAccount:  '',
            creditVat: '0',
            description: 'Oppgjør Klarna, ref: '+paymentReference,
            amount: Number(feeAmount.replace(',','.')).toString()
        })
        entryLines.push({
            date: date?.substring(0,10),
            debitAccount: '',
            debitVat: '0',
            creditAccount:  importConfig.debitAccount,
            creditVat: '0',
            description: 'Oppgjør Klarna, ref: '+paymentReference,
            amount: saleAmount
        })
    })
    // possibly more than one settlement per line? If so make entries for each
    return entryLines
}

export const customRowMapper = (data: string[][]): EntryLineFields[] => {
    const cleanRows = data.filter((row: string[]) => row[0] !== '')
    return cleanRows.map((line: string[]) => {
        const [date, debitAccount, debitVat, creditAccount, creditVat, description, amount, project, department, accrAcc, accrStartYear, accrStartMonthOneIndexed, accrDuration] = line
        return {
            date,
            debitAccount,
            debitVat,
            creditAccount,
            creditVat,
            description,
            amount,
            project,
            department,
            accrAcc,
            accrStartYear,
            accrStartMonthOneIndexed,
            accrDuration
        }
    })
}